import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import ImageWrapper from '@sputnik/components/ImageWrapper'

import styles from './styles.module.scss'

const BillBrandLogo = () => {
  const [getClassName, makeTestId] = useNameFormatter('BillBrandLogo')
  return (
    <div className={styles[getClassName('logo')]}>
      <ImageWrapper
        alt='bill-logo'
        assetsPath='logos'
        className={getClassName('')}
        dataTestId={makeTestId('')}
        imageName='bill-logo-color'
      />
    </div>
  )
}

export default BillBrandLogo
